import config from "./config";

const directory = config.typingdefense.directory;
const typingDefense = [
    {
        category: "B2L15",
        link: `${config.flashUrl}/${directory}/B2L15`,
        target: true
    },
    {
        category: "B2L16",
        link: `${config.flashUrl}/${directory}/B2L16`,
        target: true
    },
    {
        category: "B2L17",
        link: `${config.flashUrl}/${directory}/B2L17`,
        target: true
    },
    {
        category: "L01_1",
        link: `${config.flashUrl}/${directory}/L01_1`,
        target: true
    },
    {
        category: "L01_2",
        link: `${config.flashUrl}/${directory}/L01_2`,
        target: true
    },

    {
        category: "L02_1",
        link: `${config.flashUrl}/${directory}/L02_1`,
        target: true
    },
    {
        category: "L02_2",
        link: `${config.flashUrl}/${directory}/L02_2`,
        target: true
    },

    {
        category: "L03_1",
        link: `${config.flashUrl}/${directory}/L03_1`,
        target: true
    },
    {
        category: "L03_2",
        link: `${config.flashUrl}/${directory}/L03_2`,
        target: true
    },

    {
        category: "L03_3",
        link: `${config.flashUrl}/${directory}/L03_3`,
        target: true
    },
    {
        category: "L04_1",
        link: `${config.flashUrl}/${directory}/L04_1`,
        target: true
    },

    {
        category: "L04_2",
        link: `${config.flashUrl}/${directory}/L04_2`,
        target: true
    },
    {
        category: "L04_3",
        link: `${config.flashUrl}/${directory}/L04_3`,
        target: true
    },

    {
        category: "L05_1",
        link: `${config.flashUrl}/${directory}/L05_1`,
        target: true
    },
    {
        category: "L05_2",
        link: `${config.flashUrl}/${directory}/L05_2`,
        target: true
    },

    {
        category: "L05_3",
        link: `${config.flashUrl}/${directory}/L05_3`,
        target: true
    },
    {
        category: "L06_1",
        link: `${config.flashUrl}/${directory}/L06_1`,
        target: true
    },

    {
        category: "L06_2",
        link: `${config.flashUrl}/${directory}/L06_2`,
        target: true
    },
    {
        category: "L07_1",
        link: `${config.flashUrl}/${directory}/L07_1`,
        target: true
    },

    {
        category: "L07_2",
        link: `${config.flashUrl}/${directory}/L07_2`,
        target: true
    },
    {
        category: "L08_1",
        link: `${config.flashUrl}/${directory}/L08_1`,
        target: true
    },

    {
        category: "L08_2",
        link: `${config.flashUrl}/${directory}/L08_2`,
        target: true
    },
    {
        category: "L09_1",
        link: `${config.flashUrl}/${directory}/L09_1`,
        target: true
    },
    {
        category: "L09_2",
        link: `${config.flashUrl}/${directory}/L09_2`,
        target: true
    },
    {
        category: "L10_1",
        link: `${config.flashUrl}/${directory}/L10_1`,
        target: true
    },
    {
        category: "L10_2",
        link: `${config.flashUrl}/${directory}/L10_2`,
        target: true
    },
    {
        category: "L10_3",
        link: `${config.flashUrl}/${directory}/L10_3`,
        target: true
    },
    {
        category: "L11_1",
        link: `${config.flashUrl}/${directory}/L11_1`,
        target: true
    },
    {
        category: "L11_2",
        link: `${config.flashUrl}/${directory}/L11_2`,
        target: true
    },
    {
        category: "L12_1",
        link: `${config.flashUrl}/${directory}/L12_1`,
        target: true
    },
    {
        category: "L12_2",
        link: `${config.flashUrl}/${directory}/L12_2`,
        target: true
    },
    {
        category: "S_L01_1",
        link: `${config.flashUrl}/${directory}/S_L01_1`,
        target: true
    },
    {
        category: "S_L01_2",
        link: `${config.flashUrl}/${directory}/S_L01_2`,
        target: true
    },
    {
        category: "S_L02_1",
        link: `${config.flashUrl}/${directory}/S_L02_1`,
        target: true
    },
    {
        category: "S_L02_2",
        link: `${config.flashUrl}/${directory}/S_L02_2`,
        target: true
    },
    {
        category: "S_L03_1",
        link: `${config.flashUrl}/${directory}/S_L03_1`,
        target: true
    },
    {
        category: "S_L03_2",
        link: `${config.flashUrl}/${directory}/S_L03_2`,
        target: true
    },
    {
        category: "S_L03_3",
        link: `${config.flashUrl}/${directory}/S_L03_3`,
        target: true
    },
    {
        category: "S_L04_1",
        link: `${config.flashUrl}/${directory}/S_L04_1`,
        target: true
    },
    {
        category: "S_L04_2",
        link: `${config.flashUrl}/${directory}/S_L04_2`,
        target: true
    },
    {
        category: "S_L04_3",
        link: `${config.flashUrl}/${directory}/S_L04_3`,
        target: true
    },
    {
        category: "S_L05_1",
        link: `${config.flashUrl}/${directory}/S_L05_1`,
        target: true
    },
    {
        category: "S_L05_2",
        link: `${config.flashUrl}/${directory}/S_L05_2`,
        target: true
    },
    {
        category: "S_L05_3",
        link: `${config.flashUrl}/${directory}/S_L05_3`,
        target: true
    },
    {
        category: "S_L06_1",
        link: `${config.flashUrl}/${directory}/S_L06_1`,
        target: true
    },
    {
        category: "S_L06_2",
        link: `${config.flashUrl}/${directory}/S_L06_2`,
        target: true
    },
    {
        category: "S_L07_1",
        link: `${config.flashUrl}/${directory}/S_L07_1`,
        target: true
    },
    {
        category: "S_L07_2",
        link: `${config.flashUrl}/${directory}/S_L07_2`,
        target: true
    },
    {
        category: "S_L08_1",
        link: `${config.flashUrl}/${directory}/S_L08_1`,
        target: true
    },
    {
        category: "S_L08_2",
        link: `${config.flashUrl}/${directory}/S_L08_2`,
        target: true
    },
    {
        category: "S_L09_1",
        link: `${config.flashUrl}/${directory}/S_L09_1`,
        target: true
    },
    {
        category: "S_L09_2",
        link: `${config.flashUrl}/${directory}/S_L09_2`,
        target: true
    },
    {
        category: "S_L10_1",
        link: `${config.flashUrl}/${directory}/S_L10_1`,
        target: true
    },
    {
        category: "S_L10_2",
        link: `${config.flashUrl}/${directory}/S_L10_2`,
        target: true
    },
    {
        category: "S_L10_3",
        link: `${config.flashUrl}/${directory}/S_L10_3`,
        target: true
    },
    {
        category: "S_L11_1",
        link: `${config.flashUrl}/${directory}/S_L11_1`,
        target: true
    },
    {
        category: "S_L11_2",
        link: `${config.flashUrl}/${directory}/S_L11_2`,
        target: true
    },
    {
        category: "S_L12_1",
        link: `${config.flashUrl}/${directory}/S_L12_1`,
        target: true
    },
    {
        category: "S_L12_2",
        link: `${config.flashUrl}/${directory}/S_L12_2`,
        target: true
    }
];

export default typingDefense;
